<template>
  <div
    class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
    id="new-client-page"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4 box-login">
      <vx-card>
        <div slot="no-body" class="full-page-bg-color">
          <div class="vx-row">
            <div class="vx-col lg:block lg:w-1/2 mx-auto self-center">
              <!-- <img src="@/assets/images/pages/login/padlock.svg" alt="login" class="mx-auto" v-if="isDesktop"> -->
              <div class="logo-login mx-auto" :class="{'logo-login-mobile': !isDesktop}"></div>
            </div>
            <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
              <div class="p-8">
                <div class="vx-card__title mb-8">
                  <h4 class="mb-4">{{$t('NEW_CLIENT').Title}} <Flags></Flags></h4>
                  <h5 class="sub-title">{{$t('NEW_CLIENT').Title1}}</h5>
                  <h6 class="sub-title2">{{$t('NEW_CLIENT').Title2}}</h6>
                  <div class="box-content-infos">
                    <div class="items">
                      <img src="@/assets/images/pages/login/item1.svg" class="item-img" />
                      <div class="description-item" id="desc-item-1"></div>
                    </div>
                    <div class="items">
                      <img src="@/assets/images/pages/login/item2.svg" class="item-img" />
                      <div class="description-item" id="desc-item-2"></div>
                    </div>
                    <div class="items">
                      <img src="@/assets/images/pages/login/item3.svg" class="item-img" />
                      <div class="description-item" id="desc-item-3"></div>
                    </div>
                  </div>
                  <div class="form-freedays">
                    <vs-input
                      name="nome"
                      id="nome"
                      type="text"
                      icon-no-border
                      icon="icon icon-user"
                      icon-pack="feather"
                      :label-placeholder="$t('NEW_CLIENT').Name_field"
                      v-model="form.name"
                      class="w-full"
                    />
                    <vs-input
                      name="email"
                      id="email"
                      type="email"
                      v-validate="'required|email'"
                      icon-no-border
                      icon="icon icon-mail"
                      icon-pack="feather"
                      :label-placeholder="$t('NEW_CLIENT').Email_field"
                      v-model="form.email"
                      class="w-full"
                    />
                    <vs-input
                      :name="$t('NEW_CLIENT').Phone_field"
                      id="telefone"
                      type="phone"
                      icon-no-border
                      icon="icon icon-phone"
                      icon-pack="feather"
                      :label-placeholder="$t('NEW_CLIENT').Phone_field"
                      v-model="form.phone"
                      class="w-full"
                      />
                      <div class="flex flex-row-reverse">
                        <vs-button @click="onSubmit" class="btn-free">{{$t('BUTTONS').TestTrial}}</vs-button>
                        <vs-button type="border" to="/pages/login" class="btn-back">{{$t('BUTTONS').BackLogin}}</vs-button>
                      </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import userService from "../../providers/userService";
import messagesNotifyHelper from "../../helpers/messages-notify-helper";

export default {
  data() {
    return {
      showForm: true,
      form: {
        name: "",
        email: "",
        phone: ""
      }
    };
  },
  mounted() {
    document.getElementById('desc-item-1').innerHTML = this.$t("NEW_CLIENT").Description_1;
    document.getElementById('desc-item-2').innerHTML = this.$t("NEW_CLIENT").Description_2;
    document.getElementById('desc-item-3').innerHTML = this.$t("NEW_CLIENT").Description_3;
  },
  computed: {
    isDesktop() {
      return this.$store.state.isDesktop;
    }
  },
  methods: {
    sendEmail() {
      // userService
        // .requestNewClientAccess(this.form, new URLSearchParams())
        // .then(data => {
        //   this.$vs.dialog({
        //     type: "confirm",
        //     color: "primary",
        //     title: `Email enviado com sucesso !`,
        //     text: `Aguarde que nossa equipe entrará em contato para enviar seu acesso.`,
        //     accept: () => {
        //       callback();
        //     },
        //     acceptText: "OK",
        //     cancelText: "Fechar",
        //   });
        // })
    },
    onSubmit() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.sendEmail();
        } else {
          messagesNotifyHelper.errorNotify(
            this.$t("NEW_CLIENT").Notify_Error_Title,
            this.$t("NEW_CLIENT").Notify_Error_Message
          );
        }
      });
    }
  }
};
</script>

<style lang="scss">
.form-freedays {
  margin-top: 30px;
}
div#flags {
    /* right: 60px; */
    /* top: 20px; */
    float: right;
}
button.vs-component.vs-button.btn-free.vs-button-primary.vs-button-filled {
  width: 100%;
  background-color: #678b0f !important;
  margin-top: 20px;
}
.content-login {
  // margin: 20px;
}
.description-item span {
  display: contents;
  font-weight: 700;
  color: #678b0f;
}
.description-item {
  margin-top: 0px;
  margin-bottom: 10px;
  border-bottom: 1px solid #efefef;
  font-size: 11px;
  min-height: 50px;
  padding-bottom: 10px;
}
.box-login {
  width: 830px !important;
  min-height: 425px;
}
img.item-img {
  width: 55px;
  height: 55px;
  margin-right: 10px;
}
.title-box-login {
  font-weight: 600;
}
h5.sub-title {
  font-size: 18px;
  color: #678b0f;
}
.box-login {
  width: 830px !important;
  // min-height: 425px;
}
.box-content-infos div {
  display: flex;
}
h6.sub-title2 {
  margin-top: 20px;
  margin-bottom: 20px;
}
.btn-back {
    width: 120px;
    height: 40px;
    margin-top: 20px;
    margin-right: 10px;
}
</style>